import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';

interface NavBackButtonProps {
  onClick: () => void;
}

export function NavBackButton({...props}: NavBackButtonProps): ReactElement<any> {
  return (
    <Icon
      onClick={(): void => {
        props.onClick();
      }}
      className="spacing-m-r-2"
      icon="icon-back"
      size={IconSize.SIZE_ICON_20}
      type={IconType.DARK_GHOST}
      shape={IconShape.SQUARE}
    />
  );
}
